<template>
    <div style="pointer-events: auto; z-index: 1000; color: #fff;">
        <x-dialog-comp :title="titleName" @on-close="$emit('on-close')">
            <div style="height: 750px">
                <div class="neirongkuang">
                    <!-- <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">类型：</div>
                        <div class="youneirong">{{ anzhidian_type[this.xiangqinglist.type] || '-' }}</div>
                    </div> -->
                    <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">经度：</div>
                        <div class="youneirong">{{ this.xiangqinglist.longitude || '-' }}</div>
                    </div>
                    <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">纬度：</div>
                        <div class="youneirong">{{ this.xiangqinglist.latitude || '-' }}</div>
                    </div>
                    <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">承载人数(万人)：</div>
                        <div class="youneirong">{{ this.xiangqinglist.capacity || '-' }}</div>
                    </div>
                    <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">负责范围：</div>
                        <div class="youneirong">{{ this.xiangqinglist.responsibleArea || '-' }}</div>
                    </div>
                    <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">负责人：</div>
                        <div class="youneirong">{{ this.xiangqinglist.leader || '-' }}</div>
                    </div>
                    <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">所属乡镇：</div>
                        <div class="youneirong">{{ this.xiangqinglist.town || '-' }}</div>
                    </div>
                    <!-- <div class="wennei">
                        <img src="~@/assets/dapingtc/dian.png" class="xiaodiantu" />
                        <div class="zuobiaoti">成立文件</div>
                        <div class="youneirong">{{ this.xiangqinglist.establishmentFile || '-' }}</div>
                    </div> -->

                </div>
            </div>
        </x-dialog-comp>
    </div>
</template>

<script>
import {
    getDictData
} from "@/utils/dict";
import { getAzd } from "@/api/hhgl/azd";
import XDialogComp from "@/components/x-dialog-comp";
import XTitleBtn from "@/components/x-title-btn";

export default {
    name: "x-device-ShangQing",
    props: ["compData", "titleName"],
    components: {
        XTitleBtn,
        XDialogComp
    },
    data() {
        return {
            xiangqinglist: {},
            anzhidian_type: [],

        };
    },
    mounted() {
        getDictData("anzhidian_type").then((val) => {
            this.anzhidian_type = val;
        });
        if (this.compData.bindingType === "/hhgl/azd/list?pageNum=1&pageSize=9999") {
            console.log("打开安置点弹窗:", this.compData.bindingId);
            this.getanzhidianlist(this.compData.bindingId);
        }
    },
    methods: {
        getanzhidianlist(id) {
            getAzd(id).then(response => {
                this.xiangqinglist = response.data;
                console.log(
                    '%c [ this.xiangqinglist ]-434',
                    'font-size:13px; background:pink; color:#bf2c9f;',
                    this.xiangqinglist
                );
            });
        },
        closeClick() {
            this.$emit("on-close");
        }
    }
};
</script>

<style scoped>
.xiaodiantu {
    width: 20px;
    height: 20px;
    float: left;
    margin-left: 15px;
}

.zuobiaoti {
    width: 160px;
    height: 20px;
    float: left;
    text-align: left;

}

.youneirong {
    width: 885px;
    height: 20px;
    float: left;
    text-align: left;

}

.wennei {
    float: left;
    width: 100%;
    font-size: 17px;
    /* height: 30px; */
    margin-top: 10px;
}


.neirongkuang {
    height: 750px;
    width: 1085px;
    float: left;
    margin-left: 0px;
    margin-top: 0px;
    overflow-x: hidden;
    overflow-y: scroll;
}


.x-tc-page-bg {
    background: url("~@/assets/common/tanChuang.png") no-repeat;
    background-size: 100% 100%;
    width: 1132px;
    height: 763px;
    position: fixed;
    top: 100px;
    left: 400px;
    z-index: 99999;
    margin-left: 55px;
}

.x-tc-title {
    font-size: 22px;
    position: absolute;
    left: 80px;
    top: 15px;
    color: white;
    letter-spacing: 5px;
}

.x-close {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 30px;
    cursor: pointer;
}

.x-tc-cnt {
    height: 640px;
    width: 1050px;
    overflow: auto;
}
</style>